import './App.css';
import { Outlet, Link, useLocation } from "react-router-dom";
import {apiUrl} from './helpers/httpClient';
import { useState, useEffect } from 'react';
import getSocialIcon from './helpers/social';
import { usePosterColors } from './PosterContext';

function Layout() {
  const [navOpen, setNavOpen] = useState(false);
  const [website, setWebsite] = useState()
  const [isScrolled, setIsScrolled] = useState(false);
  const { posterColors } = usePosterColors();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (window.__WEBSITE__) {
      setWebsite(window.__WEBSITE__);
    }
  }, []);

  useEffect(() => {
    const closeNav = () => setNavOpen(false);
    window.addEventListener('popstate', closeNav);
    return () => window.removeEventListener('popstate', closeNav);
  }, []);

  const location = useLocation();
  const menuColor = (!navOpen && posterColors?.overlayColor) ? posterColors.overlayColor : undefined;

  return (
    <div className="App">
        {website &&
      <div className="app-container">
          <header className={`header${isScrolled ? ' header-hidden' : ''}${navOpen ? ' open' : ''}`}>
            <div className="header-container">
              <a href="/" className="logo" style={menuColor ? { color: menuColor } : undefined}>{website.title}</a>
              <button
                className={`burger${navOpen ? ' open' : ''}`}
                aria-label={navOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={navOpen}
                aria-controls="primary-navigation"
                onClick={() => setNavOpen(!navOpen)}
              >
                <span style={menuColor ? { background: menuColor } : undefined}></span>
                <span style={menuColor ? { background: menuColor } : undefined}></span>
                <span style={menuColor ? { background: menuColor } : undefined}></span>
              </button>
              <nav id="primary-navigation backColor" className={`nav${navOpen ? " open" : ""}`}>
                {website.menu.items.map((item, index) => (
                  <Link
                    key={index}
                    to={'/' + item.slug}
                    className={location.pathname === '/' + item.slug ? 'active' : ''}
                    style={menuColor ? { color: menuColor } : undefined}
                    onClick={() => setNavOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>
            </div>
          </header>

          <main className="main-content">
            <Outlet />
          </main>

          <footer className="footer">
            <div className="footer-container">
              <p>© {new Date().getFullYear()} {website.title}. All rights reserved.</p>
              <div className="social-links">
                {[...website.socials.items].sort((a, b) => {
                  const typeA = String(a.social || '').trim().toLowerCase();
                  const typeB = String(b.social || '').trim().toLowerCase();
                  const isPhoneA = typeA === 'phone' || typeA === 'tel';
                  const isPhoneB = typeB === 'phone' || typeB === 'tel';
                  if (isPhoneA && !isPhoneB) return 1;
                  if (!isPhoneA && isPhoneB) return -1;
                  return 0;
                }).map((item, idx) => {
                  const icon = getSocialIcon(item.social);
                  const type = String(item.social || '').trim().toLowerCase();
                  const isPhone = type === 'phone' || type === 'tel';
                  const isEmail = type === 'email' || type === 'mail';
                  const isContact = isEmail || isPhone;
                  let url = item.url;
                  if (isEmail && !url.startsWith('mailto:')) {
                    url = `mailto:${url}`;
                  }
                  return (
                    <a key={idx} href={url} target="_blank" rel="noopener noreferrer" className="social-link" aria-label={item.social}>
                      {icon || item.social}
                      {isPhone && (
                        <span className="phone-text" style={{ marginLeft: '0.5em' }}>{item.url}</span>
                      )}
                    </a>
                  );
                })}
              </div>
            </div>
          </footer>
      </div>
        }
    </div>
  );
}

export default Layout;
